module.exports = __webpack_public_path__ + "img/edit_call.810e6e0e.png";